module.exports = __webpack_public_path__ + "media/oph_floor.37081a8c.mp3";